/* SCREEN DETAILS */
export const GET_ALL_SCREEN_DETAILS = "GET_ALL_SCREEN_DETAILS"
export const GET_ALL_SCREEN_DETAILS_SUCCESS = "GET_ALL_SCREEN_DETAILS_SUCCESS"
export const GET_ALL_SCREEN_DETAILS_FAIL = "GET_ALL_SCREEN_DETAILS_FAIL"